export enum QueryKeys {
  ImagesByMedia = "imagesByMedia",
  Notifications = "notifications",
  Article = "article",
  ArticlesByGroup = "articlesByGroup",
  ArticlesByMediaAndProductArticleId = "articlesByMediaAndProductArticleId",
  ArticlesByMedia = "articlesByMedia",
  Medias = "medias",
  Media = "media",
  GroupsByMedia = "groupsByMedia",
  EdsData = "edsData",
  Group = "group",
  SignedUrls = "signedUrls",
  MediasAndArticleCount = "mediasAndArticleCount",
  SalesStopData = "salesStopData",
  SearchArticlesInMedias = "searchArticlesInMedias",
  TaskLinksByArticle = "taskLinksByArticle",
  TaskLinksByMedia = "taskLinksByMedia",
  TaskLinksByStore = "taskLinksByStore",
  CombinationArticle = "combinationArticle",
}
